import { z } from 'zod';

export const ratingSchema = z.object({
  recipeId: z.string().uuid(),
  mealPlanId: z.string().uuid().nullable(),
  rating: z.number().int().min(1).max(5),
});
export type Rating = z.infer<typeof ratingSchema>;

export const bulkRatingRequestSchema = z.array(ratingSchema).min(1).max(21);
export type BulkRatingRequest = z.infer<typeof bulkRatingRequestSchema>;

export const statsResponseSchema = z.object({
  totalXp: z.number().int().nonnegative(),
  level: z.number().int().min(1),
  levelTitle: z.string(),
  xpToNextLevel: z.number().int().nullable(),
  weekStreak: z.number().int().nonnegative(),
  longestStreak: z.number().int().nonnegative(),
  totalPlans: z.number().int().nonnegative(),
  savingsEstimate: z.number().nonnegative(),
});
export type StatsResponse = z.infer<typeof statsResponseSchema>;

export const achievementSchema = z.object({
  key: z.string(),
  name: z.string(),
  description: z.string(),
  unlockedAt: z.string().nullable(),
});
export type Achievement = z.infer<typeof achievementSchema>;
